import {
  FileTextOutlined,
  CloseCircleOutlined,
  BarChartOutlined,
  ClockCircleOutlined,
  TagOutlined,
  LikeOutlined,
  FileProtectOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import { CANCELLED } from "dns";

export const COLOR_OPTIONS = [
  "#E4A76A",
  "#DB805D",
  "#CAD07C",
  "#79BCC2",
  "#315685",
  "#5641D1",
  "#FF5733",
  "#C70039",
  "#900C3F",
  "#FFC300",
];

export const DATE_RANGE_MAP = {
  today: {
    fromDate: dayjs().startOf("day").format("YYYY-MM-DD"),
    toDate: dayjs().endOf("day").format("YYYY-MM-DD"),
  },
  yesterday: {
    fromDate: dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD"),
    toDate: dayjs().subtract(1, "day").endOf("day").format("YYYY-MM-DD"),
  },
  this_week: {
    fromDate: dayjs().startOf("week").format("YYYY-MM-DD"),
    toDate: dayjs().endOf("week").format("YYYY-MM-DD"),
  },
  last_week: {
    fromDate: dayjs().subtract(1, "week").startOf("week").format("YYYY-MM-DD"),
    toDate: dayjs().subtract(1, "week").endOf("week").format("YYYY-MM-DD"),
  },
  this_month: {
    fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
    toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  },
  last_month: {
    fromDate: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
    toDate: dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
  },
};

export const STATUS_DISPLAY_NAME = {
  PENDING: "Pending",
  DEMO: "Demo",
  ASSIGNED: "Assigned",
  CONFIRMED: "Confirmed",
  NEW: "New",
  IN_PROGRESS: "In Progress",
  ESCALATE: "Escalate",
  INACTIVE: "Inactive",
  PROSPECT: "Prospect",
  NOT_INTERESTED: "Not Interested",
  WAITING_RESPONSE: "Waiting Response",
  CALL_NOT_RECEIVED: "Call Not Received",
  DOC_DONE: "Doc Done",
  INTERESTED: "Interested",
  PAYMENT_DONE: "Payment Done",
  VERIFIED: "Verified",
  ACTIVE: "Active",
  BLOCKED: "Blocked",
  SHADOW_TEACHERS: "Shadow Teachers",
};

// export const STUDENT_STATUS = {

//   PENDING: 'pending',
//   DEMO: 'demo',
//   ASSIGNED: 'assigned',
//   CONFIRMED: 'confirmed',
//   NEW: 'new',
//   IN_PROGRESS: 'in_progress',
//   ESCALATE: 'escalate',
//   INACTIVE: 'inactive',
//   PROSPECT: 'prospect',
//   NOT_INTERESTED: 'Not_interested'
// };
// NEW > PROSPECT > NOT INTERESTED > ACTIVE > INPROGRESS > PENDING > ESCALATED > ASSIGNED
// > DEMO > PAYMENT PENDING > CONFIRMED > CANCELLED > REPLACED > INACTIVE
export const STUDENT_STATUS = {
  // this is for request
  NEW: "new",
  PROSPECT: "prospect",
  NOT_INTERESTED: "not_interested",
  ACTIVE: "active",
  IN_PROGRESS: "in_progress",
  PENDING: "pending",
  ESCALATE: "escalate",
  ASSIGNED: "assigned",
  DEMO: "demo",
  PAYMENT_PENDING: "payment_pending",
  WAITING_RESPONSE: "waiting_response",
  CALL_NOT_RECEIVED: "call_not_received",
  CONFIRMED: "confirmed",
  CANCELLED: "cancelled",
  REPLACED: "replaced",
  INACTIVE: "inactive",
  // this is for priority status
  P1: "p1",
  P2: "p2",
  P3: "p3",
  // subscription status
  subscribed_count: "subscribed_count",
  unsubscribed_count: "unsubscribed_count",
  // expiredCountFromSubsctriptions:"expiredCountFromSubsctriptions",
  // subscribedCountFromSubsctriptions:"subscribedCountFromSubsctriptions"
};
export const student_status = {
  // this is for response
  new: "NEW",
  prospect: "PROSPECT",
  not_interested: "NOT_INTERESTED",
  active: "ACTIVE",
  in_progress: "IN_PROGRESS",
  pending: "PENDING",
  escalate: "ESCALATE",
  assigned: "ASSIGNED",
  demo: "DEMO",
  payment_pending: "PAYMENT_PENDING",
  waiting_response: "WAITING_RESPONSE",
  call_not_received: "CALL_NOT_RECEIVED",
  confirmed: "CONFIRMED",
  cancelled: "CANCELLED",
  replaced: "REPLACED",
  inactive: "INACTIVE",
  // this is for priority status response
  p1: "P1",
  p2: "P2",
  p3: "P3",
  // subscription status
  subscribed_count: "subscribed_count",
  unsubscribed_count: "unsubscribed_count",
  expiredCountFromSubsctriptions: "expiredCountFromSubsctriptions",
  subscribedCountFromSubsctriptions: "subscribedCountFromSubsctriptions",
};

export const TUTOR_STATUS = {
  NEW: "new",
  DOC_DONE: "doc_done",
  INTERESTED: "interested",
  NOT_INTERESTED: "not_interested",
  PAYMENT_DONE: "payment_done",
  VERIFIED: "verified",
  EXPIRED: "expired",
  ACTIVE: "active",
  INACTIVE: "inactive",
  BLOCKED: "blocked",
  SHADOW_TEACHERS: "shadow_teachers",
};

export const tutor_status = {
  new: "NEW",
  doc_done: "DOC_DONE",
  interested: "INTERESTED",
  not_interested: "NOT_INTERESTED",
  payment_done: "PAYMENT_DONE",
  verified: "VERIFIED",
  expired: "EXPIRED",
  active: "ACTIVE",
  inactive: "INACTIVE",
  blocked: "BLOCKED",
  shadow_teachers: "SHADOW_TEACHERS",
};

export const LEAD_TYPE = {
  STUDENT: 0,
  TUTOR: 1,
};

export const STATUS_ICONS = {
  New: <FileTextOutlined />,
  "Not Interested": <CloseCircleOutlined />,
  Prospect: <BarChartOutlined />,
  "In Progress": <ClockCircleOutlined />,
  Assigned: <TagOutlined />,
  Pending: <LikeOutlined />,
  Confirmed: <FileProtectOutlined />,
  Escalate: <ExclamationCircleOutlined />,
  "Doc Done": <BarChartOutlined />,
  Interested: <TagOutlined />,
  "Payment Done": <LikeOutlined />,
  Verified: <FileProtectOutlined />,
  Active: <FileProtectOutlined />,
  Inactive: <FileProtectOutlined />,
  Blocked: <FileProtectOutlined />,
  "Shadow Teachers": <FileProtectOutlined />,
};

export const DATE_FILTER_TYPE = {
  relative: "relative",
  absolute: "absolute",
};

export const getDateRange = (day: Dayjs) => {
  return day.endOf("day").format("YYYY-MM-DD");
};

export const TABLE_LIMIT = 5;

export const TUTOR_PROCESS_STATUS = {
  ASSIGNED: "cyan",
  // INTERESTED: "blue",
  // NOT_INTERESTED: "volcano",
  DEMO_SCHEDULED: "gold",
  CONFIRMED: "green",
  CANCELLED: undefined,
  REJECTED: "red",
  // IN_PROGRESS: "lime",
  REMOVED: "orange",
};

export const SHORTLISTED_TUTOR_PROCESS_STATUS = {
  IN_PROGRESS: "lime",
  INTERESTED: "blue",
  NOT_INTERESTED: "volcano",
};

export const STUDENT_DEALINGS_STATUS_COLORS = {
  PENDING: "magenta",
  DEMO: "cyan",
  ASSIGNED: "green",
  CONFIRMED: "success",
  NEW: "volcano",
  IN_PROGRESS: "orange",
  ESCALATE: "blue",
  INACTIVE: "geekblue",
  PROSPECT: "gold",
  NOT_INTERESTED: "error",
  REPLACED: "lime",
  ACTIVE: "green",
  CANCELLED: "silver",
  PAYMENT_PENDING: "yellow",
  WAITING_RESPONSE: "purple",
  CALL_NOT_RECEIVED: "default",
};

export const STUDENT_DEALINGS_PRIORITY_LEVEL_COLORS = {
  P1: "#f50000",
  P2: "#d7cd09",
  P3: "#5abc2f",
};

export const API_TIME_FORMAT = "HH:mm:ss";
export const timeFromString = (timeAsString: string) => {
  if (!timeAsString) return null;
  const dayjsConv = dayjs(timeAsString, API_TIME_FORMAT);
  if (typeof dayjsConv.isValid === "function" && dayjsConv.isValid()) {
    return dayjsConv;
  }
  return null;
};
export const toTimeString = (time: dayjs.Dayjs | null) => {
  if (!time || !(typeof time.isValid === "function" && time.isValid())) return "";
  return time.format(API_TIME_FORMAT);
};

export const toTimeStringDisplay = (time: dayjs.Dayjs | null) => {
  if (!time || !(typeof time.isValid === "function" && time.isValid())) return "";
  return time.format(`h:mm A`);
};

export const DAYS_PER_WEEK_MASTER = [
  "1 Day a week",
  "2 Days a week",
  "3 Days a week",
  "4 Days a week",
  "5 Days a week",
  "6 Days a week",
];

export const CourseCategories = {
  "school education": "1",
  Curricular: "2",
  "Competitive Exams": "3",
  "Intermediate Courses": "4",
  "Abroad Exams": "5",
  "Learn Language": "6",
  "IT Courses": "7",
  "Special Kids (ADHD /ADD /AUTISM)": "13",
  1: "school education",
  2: "Curricular",
  3: "Competitive Exams",
  4: "Intermediate Courses",
  5: "Abroad Exams",
  6: "Learn Language",
  7: "IT Courses",
  13: "Special Kids (ADHD /ADD /AUTISM)",
};
